<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="500px" persistent>
    <v-card>
      <v-card-title class="title">
        Add Tag for&nbsp;<span v-if="item && item.userHandle"> @{{item.userHandle}}</span>
      </v-card-title>
      <v-card-text class="mt-3 body-2">
        <div>
          <!-- <v-text-field
            dense
            v-model="updateData.tag"
            type="text"
            placeholder="Tag"
            outlined
            @input="$v.updateData.tag.$touch()"
            :error-messages="$v.updateData.tag.$error && `Tag is required.`"
            @blur="$v.updateData.tag.$touch()"
          ></v-text-field> -->
          <v-combobox
            v-model="updateData.tag"
            :items="allTags"
            item-text="name"
            item-value="name"
            hide-selected
            chips
            label="Tag"
            multiple
            @input="$v.updateData.tag.$touch()"
            :error-messages="$v.updateData.tag.$error && `Tag is required.`"
            @blur="$v.updateData.tag.$touch()"
          >
            <template v-slot:selection="{ attrs, item, parent, selected }">
              <v-chip
                v-if="item === String(item)"
                v-bind="attrs"
                :input-value="selected"
                label
                small
              >
                <span class="pr-2">
                  {{ item }}
                </span>
                <v-icon
                  small
                  @click="parent.selectItem(item)"
                >
                  $delete
                </v-icon>
              </v-chip>
              <v-chip
                v-if="item === Object(item)"
                v-bind="attrs"
                :input-value="selected"
                label
                small
              >
                <span class="pr-2">
                  {{ item.name }}
                </span>
                <v-icon
                  small
                  @click="parent.selectItem(item)"
                >
                  $delete
                </v-icon>
              </v-chip>
            </template>
          </v-combobox>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" id="close" text @click.native="close()">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="save()" :disabled="$v.updateData.$invalid">Save</v-btn>
      </v-card-actions>
    </v-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
  </v-dialog>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
// import userAPIs from '../User/userAPIs';
// import config from '@/config';
// import moment from 'moment'
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
export default {
  name: 'AddTagModal',
  components: {
    Loading
  },
  props: {
    value: Boolean,
    item: Object
  },
  validations: {
    updateData: {
      tag: { required }
    }
  },
  data () {
    return {
      isLoading: false,
      updateData: {
        tag: []
      }
    }
  },
  async mounted() {
    this.getAllTags()
  },
  computed: {
    ...mapState({
      allTags: state => state.influencer.allTags,
      customTag: state => state.influencer.customTag,
      updatedTag: state => state.influencer.updatedTag
    })
  },
  watch: {
    value: async function(newValue) {
      this.updateData = {
        tag: []
      }
      this.getTags()
    }
  },
  methods: {
    async save() {
      this.isLoading = true
      if (this.updateData.tag) {
        this.updateData.tag = this.updateData.tag.map(item => {
          if (typeof item === 'object') {
            return item.name
          }
          return item
        })
      }
      let saveData = Object.assign({}, {
        influencerID: this.item.influencerID,
        handle: this.item.userHandle,
        platform: this.item.platform,
        ...this.updateData
      })
      await this.$store.dispatch('influencer/updateTag', {
        updateData: saveData
      })
      this.isLoading = false
      if (this.updatedTag) {
        this.$swal({
          text: 'Successfully Updated.',
          type: 'success'
        })
        this.$emit('saved', this.updateData.tag)
        this.close()
      } else {
        this.$swal({
          text: 'Error Updating Tag!',
          type: 'error'
        })
      }
    },
    async getTags() {
      await this.$store.dispatch('influencer/getCustomTags', {
        filters: {
          handle: this.item.userHandle
        }
      })
      if (this.customTag) {
        if (this.customTag.names) {
          this.updateData.tag.push(...this.customTag.names)
        }
      }
    },
    async getAllTags() {
      await this.$store.dispatch('influencer/getAllTags')
    },
    close() {
      this.$emit('input')
    }
  }
};
</script>



// WEBPACK FOOTER //
// AddTagModal.vue?9dcecaae